const routes = {
  EXAM: 'placement_test/schedules/',
  EXAM_RESULT: 'placement_test/schedules/:token/results'
}

export default routes
